import usePageTitle from '@/hooks/use-page-title';
import { Link, Route, Routes } from "react-router-dom";
import { ChevronRight } from 'lucide-react';
import Cotisations from "@/pages/paiements/cotisations";
import Prelevements from "@/pages/paiements/prelevements";
import PromoBlocs from '@/pages/home/promo-blocs';
import { HOST_MB } from '@/lib/constants';
import SmallSpinner from '@/components/shared/spinners/small-spinner';
import { useReceiptsUnpaid } from '@/hooks/api/use-receipts';
import { useCurrentUser } from '@/hooks/api/use-user';

const Paiements = () => {
    usePageTitle('Mes paiements');
    const isEligibleParrainage = useCurrentUser().eligible_parrainage;
    // Relu à chaque arrivée sur l'écran, comme l'ancien `load`.
    const receiptsQuery = useReceiptsUnpaid();

    if (receiptsQuery.isPending) return <SmallSpinner />;

    return (
        <div className="w-full">
            <nav className="flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground mt-4" aria-label="Fil d'Ariane">
                <Link to="/" className="hover:text-foreground transition-colors no-underline">Mon espace</Link>
                <ChevronRight className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                <Link to="/mes-paiements" className="hover:text-foreground transition-colors no-underline">Mes paiements</Link>
            </nav>
            <div className="space-y-2 sm:space-y-3 mt-4">
                <h1 className="text-xl sm:text-2xl font-bold">Mes paiements</h1>
            </div>

            <Routes>
                <Route index element={<Cotisations />} />
                <Route path={'/mon-contrat/:id/mes-prelevements'} element={<Prelevements />} />
            </Routes>

            {HOST_MB === 43397 && <div className="mt-6"><PromoBlocs isEligibleParrainage={isEligibleParrainage} /></div>}
        </div>
    );
};

export default Paiements;
